import { gql } from '@apollo/client';

export const DeleteClassFirstLevel = gql`
mutation Mutation($deleteClassFirstLevelId: ID!) {
  deleteClassFirstLevel(id: $deleteClassFirstLevelId) {
    status
  }
}
`